module.exports = "/images/icono-awesome-handshake.svg?58a48fe6b161d7e1fdcde7b026f16c67";